const PROMO_KEY = "promo";
const PROMO_CODE = "MOVE32";

/*
 * The code is only held for the current browsing session, and only once the
 * donor has taken it themselves (copied it on /move32, or typed it into the
 * basket). Landing on /move32 alone does not save it, and it does not survive
 * closing the browser or finishing a booking.
 */
export function setPromoCode(): void {
  try {
    sessionStorage.setItem(PROMO_KEY, PROMO_CODE);
  } catch {
    // sessionStorage unavailable
  }
}

export function clearPromoCode(): void {
  try {
    sessionStorage.removeItem(PROMO_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

/*
 * Earlier versions kept the code in localStorage and a 10 year cookie as soon
 * as someone opened /move32. Clear that on load so nothing lingers on devices
 * that visited before. Can be removed once the campaign is over.
 */
export function clearLegacyPromoStorage(): void {
  try {
    localStorage.removeItem(PROMO_KEY);
  } catch {
    // localStorage unavailable
  }
  const domain = process.env.REACT_APP_COOKIE_DOMAIN || "droppoint.org";
  const expired = `${PROMO_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  document.cookie = `${expired}; domain=${domain}`;
  document.cookie = expired;
}

export function getPromoCode(): string | null {
  try {
    return sessionStorage.getItem(PROMO_KEY);
  } catch {
    return null;
  }
}

// A booking needs this many parcels for its cheapest label to be free (once per booking)
export const PROMO_MIN_LABELS = 3;

export function normalisePromoCode(code?: string | null): string {
  const normalised = (code || "").trim().toUpperCase();
  return normalised === PROMO_CODE ? normalised : "";
}

export { PROMO_CODE };
